// Func = limiting Scope for this file
var lastScrollTop = 0;

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

	if(!(window.ActiveXObject) && "ActiveXObject" in window) {

		/*is explorer*/
		function msieversion() {
			let ua = window.navigator.userAgent;
			let msie = ua.indexOf("MSIE ");
			if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))
			{
				const image_fit = document.getElementsByClassName('image-fit__wrapper');
				for(let i = 0; i < image_fit.length; i++ ){
					const this_image = image_fit[i].getElementsByTagName('img')[0];
					const image_data = this_image.dataset.srcset;
					const image_src = this_image.getAttribute('src');
					image_fit[i].classList.add('ie-bg');
					if(image_data){
						image_fit[i].style.backgroundImage = 'url("'+image_data+'")';
					}else{
						image_fit[i].style.backgroundImage = 'url("'+image_src+'")';
					}

				}
			}
			else
			{
				console.log('other browser');
			}
			return false;
		}
		msieversion();

	} else {
		/*****************************************************
		 OBSERVER TO ADD PARALLAX EFFECT
		 *****************************************************/
		let scrollParallax = []
		let scrolled = 0

		/* screen height */
		let v_height = window.innerHeight
			|| document.documentElement.clientHeight
			|| document.body.clientHeight;

		function doParallax(elm) {

			let boundes = elm.dataset.parallax.split(",") /* get it from html */
			/*get distance in positive value*/
			let distance = Math.abs(boundes[0] - boundes[1])
			if (boundes[0] > boundes[1]) {
				/*get distance in negative value (to do the scroll inverse)*/
				distance = distance * -1
			}
			/*Equivalent distance using screen height + element height*/
			const unit_scroll = distance / (v_height + elm.offsetHeight)
			let temp = 0

			let topElement = 0;
			let element = elm;

			let id_elem = elm.dataset.parallaxid

			do {
				topElement += element.offsetTop || 0;
				element = element.offsetParent;
			} while (element)

			let parallaxFunction = function () {
				/*Obtain the distance between top screen and document top 0*/
				scrolled = document.documentElement.scrollTop || window.pageYOffset
				/*Distance of bottom page to top of the element*/
				let relative_distance = scrolled + v_height - topElement
				/*transpoling data to move the parallax element relative to the scroll of all the screen*/
				temp = (unit_scroll * relative_distance) + parseInt(boundes[0])
				/*console.log('scroll: '+scrolled+' v_height: '+v_height+' element top: '+elm.offsetTop)*/
				elm.setAttribute('style', 'transform: translate(0, ' + temp + 'px)')
			}

			scrollParallax[id_elem] = parallaxFunction

			window.addEventListener('scroll', scrollParallax[id_elem])

		}

		let observers_parallax = document.querySelectorAll(".js-parallax-element")

		if (observers_parallax) {
			let options_parallax = {
				root: null, /* relative to document viewport */
				rootMargin: '0px', /* margin around root. Values are similar to css property. Unitless values not allowed */
				threshold: 0 /* visible amount of item shown in relation to root */
			}

			function handler_parallax(entries, observer) {
				let entry;
				entries.forEach(function (entry) {
					if (entry.isIntersecting) {
						doParallax(entry.target)
					} else {
						let id_elem = entry.target.dataset.parallaxid
						window.removeEventListener('scroll', scrollParallax[id_elem])
					}
				})
			}

			let observable_parallax = new IntersectionObserver(handler_parallax, options_parallax)
			let counter = 1
			observers_parallax.forEach(function (element) {
				observable_parallax.observe(element)
				element.dataset.parallaxid = counter
				counter++
			})
		}
		/********************************************************************************
		 END OF OBSERVER TO ADD PARALLAX EFFECT
		 ***********************************************************************************/
	}

	/* Text and Form Animations */
	let formModule = document.querySelectorAll('.form-module-wrapper form');
	let textModule = document.querySelectorAll('.text-modules-wrapper .text-modules');
	if(formModule){
		formModule.forEach(function(form_module) {
			form_module.classList.add('animate-fade', 'top');
		});
	}
	if(textModule){
		textModule.forEach(function(text_module) {
			text_module.classList.add('animate-fade', 'top');
		});
	}

	/* Remove empty <p> tags created by tinymce */
	const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

	//// Forms animation for labels   ----------------------------------------------------------------
	if (document.getElementById('email-signup_email_address')) {
		document.getElementById('email-signup_email_address').addEventListener('focus', function () {
			this.parentElement.classList.add('moved');
		});
	}
	if (document.getElementById('email-signup_first_name')) {
		document.getElementById('email-signup_first_name').addEventListener('focus', function () {
			this.parentElement.classList.add('moved');
		});
	}
	if (document.getElementById('email-signup_last_name')) {
		document.getElementById('email-signup_last_name').addEventListener('focus', function () {
			this.parentElement.classList.add('moved');
		});
	}
	//CMS forms label animation ----------------------------------------------------------------
	if (document.getElementsByClassName('form-module__field').length > 0) {
		const MODULE_FIELDS = document.querySelectorAll('.form-module__field');
		MODULE_FIELDS.forEach((field) => {
			if (field.getElementsByTagName('input').length > 0) {
				if (field.getElementsByTagName('input')[0].type.toLowerCase() != 'checkbox' && field.getElementsByTagName('input')[0].type.toLowerCase() != 'radio') {
					field.getElementsByTagName('input')[0].addEventListener('focus', function () {
						this.parentElement.classList.add('moved');
					});
				}
			}
			if (field.getElementsByTagName('select').length > 0) {
				field.getElementsByTagName('select')[0].addEventListener('focus', function () {
					this.parentElement.classList.add('moved');
				});
			}
			if (field.getElementsByTagName('textarea').length > 0) {
				field.getElementsByTagName('textarea')[0].addEventListener('focus', function () {
					this.parentElement.classList.add('moved');
				});
			}
		});
	}

	document.addEventListener('DOMContentLoaded', () => {
		// ---------------------------------------------------------------- GENERAL SITE'S FUNCTIONS ----------------------------------------------------------------
		if(document.getElementById('header').classList.contains('no-hero')){
			document.getElementById('header').classList.add('scroll');
			let logoUrl = '/assets/svg/logo-scroll.svg';
			document.getElementsByClassName('header__logo')[0].getElementsByTagName('img')[0].setAttribute('src',logoUrl);
		} else{
			scrollW();
			window.addEventListener('scroll', function(){
				scrollW();
			})
		}

		

		// Main Nav Dropdown
		let primaryNav = document.getElementById('primary-nav');
		if(primaryNav){
			primaryNav.querySelectorAll('li').forEach(function(primary_nav) {
				primary_nav.addEventListener("mouseover", (event) => {
					primary_nav.classList.add('hover');
					if(primary_nav.querySelector('ul.submenu')){
						primary_nav.querySelector('ul.submenu').classList.add('open');
					}
				});
				primary_nav.addEventListener("mouseout", (event) => {
					primary_nav.classList.remove('hover');
					if(primary_nav.querySelector('ul.submenu')){
						primary_nav.querySelector('ul.submenu').classList.remove('open');
					}
				});
			});
		}

		let secondaryNav = document.getElementById('secondary-header-ul_nav');
		if(secondaryNav){
			secondaryNav.querySelectorAll('li').forEach(function(secondary_nav) {
				secondary_nav.addEventListener("mouseover", (event) => {
					secondary_nav.classList.add('hover');
					if(secondary_nav.querySelector('ul.submenu')){
						secondary_nav.querySelector('ul.submenu').classList.add('open');
					}
				});
				secondary_nav.addEventListener("mouseout", (event) => {
					secondary_nav.classList.remove('hover');
					if(secondary_nav.querySelector('ul.submenu')){
						secondary_nav.querySelector('ul.submenu').classList.remove('open');
					}
				});
			});
		}


		// Lightbox Gallerys

		const customLightbox = new LBX('.js-lbx-gallery', {
			customClass:'lbx-gallery',
		});

		// Gallery flex fade transition

		let galleryContainer = document.querySelector('#gallery-flex #content');

		if(galleryContainer){
			setTimeout(() => {
				galleryContainer.style.opacity = 1;
			}, 500);
		}

		// BURGUER MENU MOBILE ----------------------------------------------------------------

		const burgerMenuBtn = document.querySelector("#js-burgerMenuBtn");
		const burgerMenuContainer = document.querySelector("#js-menuContainer")
		const closeMenu = document.querySelector(".js-burger-close");
		
		//Open Menu

		if(burgerMenuBtn){
			burgerMenuBtn.addEventListener('click', function (e) {
				e.preventDefault();
				burgerMenuContainer.classList.add("open");
				document.body.classList.add("no-scroll");
			});
		}
		
		if(closeMenu){
			closeMenu.addEventListener('click', () => {
				burgerMenuContainer.classList.remove("open");
				document.body.classList.remove("no-scroll");
			});
		}

		// SHOW SUBMENU FUNCTION: 

		const submenuToShow = (linksSelector, linkSubmenu) => {
			let navLinks = document.querySelectorAll(linksSelector); 
			let submenu_active = document.querySelectorAll(linkSubmenu); 

			navLinks.forEach(link => {
				const parent = link.parentNode;
				let submenu = parent.querySelector('.submenu');
				link.addEventListener('click', (e) => {
					document.querySelectorAll('.submenu.active').forEach(activeSubmenu => {
						activeSubmenu.classList.remove('active');
					});
					document.querySelectorAll(`${linksSelector}.active`).forEach(activeLink => {
						activeLink.classList.remove('active');
					});
					link.classList.toggle('active');
					submenu.classList.toggle('active');
				});
			});
			submenu_active.forEach(sub => {
				if (sub.classList.contains('active')) {
					if (window.screen.width > 640) {
						let selectedLink = sub.parentNode.parentNode.parentNode.children[0];
						selectedLink.classList.add('selected');
					}else{
						let selectedLink = sub.parentNode.parentNode.parentNode.parentNode.children[0];
						selectedLink.classList.add('selected');
					}
				}

			})
		}

		if (window.screen.width > 640) {
			submenuToShow('#primary-nav li a', '.submenu li a');
		} else {
			submenuToShow('.mobileMenu__nav li a', '.sub-sub-menu .submenu li a');
		}


		const navItems = document.querySelectorAll('.privary-navigation__item');
		const navItemsMob = document.querySelectorAll('.mobileMenu__nav li');
		
		function addNoSubmenuClass() {
			navItems.forEach(item => {
				
				const submenu = item.querySelector('.privary-navigation__submenu');
				if (!submenu) {
					item.classList.add('no-submenu');
				}
			});
		}
		
		function addNoSubmenuMobileClass() {
			navItemsMob.forEach(item => {
				
				const submenu = item.querySelector('.sub-sub-menu');

				
				if (!submenu) {
					item.classList.add('no-submenu');
				}
			});

		}
		if(window.screen.width > 768) {
			addNoSubmenuClass();
		}else{
			addNoSubmenuMobileClass()
		}

	});

	animateto();

	// ---------------------------------------------------------------- INDIVIDUAL SITE'S FUNCTIONS ----------------------------------------------------------------
	/** ADA Tab Links Functionality for Keyboard Navigation in Menu **/
	// function updateMenuTabIndex() {
	// 	const menu = document.querySelector('#menu-desktop');
	// 	const isMenuVisible = menu && menu.classList.contains('open');
	// 	const elements = document.querySelectorAll('.privary-navigation__item a, .secondary-navigation__item a');
	// 	elements.forEach(element => {
	// 		element.setAttribute('tabindex', isMenuVisible ? '0' : '-1');
	// 	});
	// }
	// document.addEventListener('DOMContentLoaded', () => {
	// 	updateMenuTabIndex();

	// 	document.addEventListener('focusin', updateMenuTabIndex);
	// 	const menu = document.querySelector('#menu-desktop');
	// 	if (menu) {
	// 		menu.addEventListener('transitionend', updateMenuTabIndex);
	// 	}
	// });
})();

function animateto() {

    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            e.preventDefault();
            const targetId = this.getAttribute('href').substring(1);
            if (targetId && document.getElementById(targetId)) {
                scrollToTarget(targetId);
            }
        });
    });

   
    function scrollToTarget(target) {
        var gotoTarget = offset(document.getElementById(target)).top - 140;
        var from     = window.pageYOffset;
        var to       = gotoTarget;
        var duration = 1300;
        var start = new Date().getTime();

        var timer = setInterval(function() {
            var time = new Date().getTime() - start;
            var y;

            if (from <= to) {
                y = easeInOutQuart(time, from, to - from, duration);
            } else {
                y = easeInOutQuart(time, from, -(from - to), duration);
            }

            window.scrollTo(0, y);
            if (time >= duration) clearInterval(timer);
        }, 1000 / 60);

        window.scrollTo(0, from);
    }
}

/* Ease Movement */
function easeInOutQuart(t, b, c, d) {
	if ((t /= d / 2) < 1) return c / 2 * t * t * t * t + b;
	return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
}
function offset(el) {
	var rect = el.getBoundingClientRect(),
		scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
		scrollTop = window.pageYOffset || document.documentElement.scrollTop;
	return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}
/* ScrollW */
function scrollW(){
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 25){
		// downscroll code
		if(!document.getElementById('header').classList.contains('scroll')){
			document.getElementById('header').classList.add('scroll');
			document.getElementById('top-content').classList.add('scroll');
			let logoUrl = '/assets/svg/logo-scroll.svg';
			document.getElementsByClassName('header__logo')[0].getElementsByTagName('img')[0].setAttribute('src',logoUrl)
		}
	} else {
		if(document.getElementById('header').classList.contains('scroll')){
			document.getElementById('header').classList.remove('scroll');
			document.getElementById('top-content').classList.remove('scroll');
			let logoUrl = '/assets/svg/logo.svg';
			document.getElementsByClassName('header__logo')[0].getElementsByTagName('img')[0].setAttribute('src',logoUrl)
		}
	}
	
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}


